import React, { ReactElement } from 'react'
import WidgetError from '../WidgetError'

interface ApiErrorProps {
  errorMsg?: string
  shouldRender: boolean | undefined
}

const ApiError: React.FC<ApiErrorProps> = ({
  errorMsg,
  shouldRender,
}): ReactElement => {
  if (shouldRender) {
    return <WidgetError heading={errorMsg} />
  }

  return <></>
}

export default ApiError
